/**
 * Hardcoded fallback branding for the main Total Wireless Repair Center
 * marketing site. The live values come from `/api/main-site-branding`
 * (super_admin editable via Admin → Settings). If the endpoint is
 * unreachable (offline, first paint), the site renders these defaults.
 *
 * Tenant POS Site Branding never affects the main site.
 */
export const MAIN_SITE_BRANDING = {
  name: 'Total Wireless Repair Center',
  phone: '(248) 677-1040',
  email: 'info@totalwirelessrepair.com',
  socials: {
    facebook: '#',
    instagram: '#',
    twitter: '#',
    tiktok: '#',
    youtube: '#',
  },
  logoUrl: '/logo-tw.png',
};

/** Strips formatting from a phone for use in a tel: href. */
export const telHref = (phone) => `tel:${(phone || '').replace(/[^0-9+]/g, '')}`;
